/* ==========================================================================
   Personalisation fee lock — keeps fee lines tied to the items they're for.

   The buy box adds a personalised item and its fee as two cart lines that
   share a hidden _fee_ref property (the item also carries _fee = the fee's
   variant id; the fee line carries _fee_line). After every cart change this
   makes the cart match:
     - each fee line's quantity = 1 per design, or its item's quantity
       when the item carries _fee_each (fee charged per item);
     - item removed → its fee is removed;
     - fee removed while the item is still there → the fee is added back;
   and hides the quantity stepper on fee lines (in Motion, stepping to 0 is
   how a line is removed), with a short note in its place.

   It's a convenience lock, not a security one: Shopify's cart can always be
   changed directly. Loaded on every page by snippets/pv-fee-lock.liquid.
   ========================================================================== */
(function () {
  if (window.__pvFeeLock) return;
  window.__pvFeeLock = true;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var NOTE = (document.currentScript && document.currentScript.getAttribute('data-note')) || 'Added with your personalisation';
  var OWN = 'X-PV-Fee-Lock';
  var lockedKeys = [];
  var realFetch = window.fetch.bind(window);

  function cartUrl(path) { return root.replace(/\/?$/, '/') + path; }
  function post(path, body) {
    var headers = { 'Content-Type': 'application/json', 'Accept': 'application/json' };
    headers[OWN] = '1';
    return realFetch(cartUrl(path), { method: 'POST', headers: headers, body: JSON.stringify(body) })
      .then(function (r) { return r.json(); });
  }

  /* ---------------- Work out what the cart should look like ---------------- */
  function plan(cart) {
    var groups = {};
    (cart.items || []).forEach(function (item) {
      var p = item.properties || {};
      var ref = p._fee_ref;
      if (!ref) return;
      var g = groups[ref] || (groups[ref] = { qty: 0, each: false, feeVariant: '', forText: '', fees: [] });
      if (p._fee_line) {
        g.fees.push(item);
      } else {
        g.qty += item.quantity;
        g.each = g.each || p._fee_each === '1';
        g.feeVariant = g.feeVariant || p._fee;
        g.forText = g.forText || (item.product_title + (item.variant_title ? ' — ' + item.variant_title : ''));
      }
    });
    var updates = {};
    var adds = [];
    var keys = [];
    Object.keys(groups).forEach(function (ref) {
      var g = groups[ref];
      // One fee per design (the default), or one per item if the line says so.
      var need = g.qty > 0 ? (g.each ? g.qty : 1) : 0;
      g.fees.forEach(function (fee, i) {
        var want = i === 0 ? need : 0;
        if (fee.quantity !== want) updates[fee.key] = want;
        if (want > 0) keys.push(fee.key);
      });
      if (!g.fees.length && need > 0 && g.feeVariant) {
        adds.push({ id: g.feeVariant, quantity: need, properties: { 'For': g.forText, '_fee_ref': ref, '_fee_line': '1' } });
      }
    });
    return { updates: updates, adds: adds, keys: keys };
  }

  /* ---------------- Make it so ---------------- */
  var running = false;
  var again = false;
  // The last fix sent. If the cart still needs the very same fix afterwards
  // (e.g. the fee product is sold out, so it can't be re-added), don't keep
  // retrying: wait for the next real cart change instead.
  var lastFix = '';
  function reconcile() {
    if (running) { again = true; return; }
    running = true;
    realFetch(cartUrl('cart.js'), { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var p = plan(cart);
        lockedKeys = p.keys;
        applyLocks();
        var steps = [];
        if (Object.keys(p.updates).length) steps.push(function () { return post('cart/update.js', { updates: p.updates }); });
        if (p.adds.length) steps.push(function () { return post('cart/add.js', { items: p.adds }); });
        if (!steps.length) { lastFix = ''; return false; }
        var fix = JSON.stringify([p.updates, p.adds]);
        if (fix === lastFix) return false;
        lastFix = fix;
        return steps.reduce(function (chain, step) { return chain.then(step); }, Promise.resolve())
          .then(function () { return true; });
      })
      .then(function (changed) {
        if (!changed) return;
        // The cart page renders server-side; the drawer rebuilds on cart:build.
        if (/\/cart\/?$/.test(location.pathname)) { location.reload(); return; }
        document.dispatchEvent(new CustomEvent('cart:build'));
        // Fee line keys can change once re-added, so look again.
        again = true;
      })
      .catch(function () {})
      .then(function () {
        running = false;
        if (again) { again = false; setTimeout(reconcile, 250); }
      });
  }

  /* ---------------- Hide the stepper on fee lines ---------------- */
  function applyLocks() {
    document.querySelectorAll('.cart__item[data-key]').forEach(function (row) {
      var locked = lockedKeys.indexOf(row.getAttribute('data-key')) !== -1;
      row.classList.toggle('pv-fee-locked', locked);
      var qty = row.querySelector('.cart__item--qty');
      if (!qty) return;
      var note = qty.parentNode.querySelector('.pv-fee-note');
      if (locked && !note) {
        note = document.createElement('div');
        note.className = 'pv-fee-note';
        note.textContent = NOTE;
        qty.parentNode.insertBefore(note, qty.nextSibling);
      } else if (!locked && note) {
        note.remove();
      }
    });
  }
  // The drawer and cart page re-render their lines; re-apply when they do.
  var lockTimer = null;
  new MutationObserver(function () {
    clearTimeout(lockTimer);
    lockTimer = setTimeout(applyLocks, 30);
  }).observe(document.documentElement, { childList: true, subtree: true });

  /* ---------------- Watch for cart changes ---------------- */
  // Any add / change / update / clear by the theme or an app (but not our
  // own requests) is followed by a check.
  var CART_WRITE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  var timer = null;
  function soon() { lastFix = ''; clearTimeout(timer); timer = setTimeout(reconcile, 300); }
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var headers = (init && init.headers) || {};
    var own = headers[OWN] || (headers.get && headers.get(OWN));
    var result = realFetch(input, init);
    if (!own && CART_WRITE.test(url)) result.then(soon, soon);
    return result;
  };
  var xhrOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (CART_WRITE.test(String(url))) this.addEventListener('loadend', soon);
    return xhrOpen.apply(this, arguments);
  };
  document.addEventListener('cart:updated', function () { setTimeout(applyLocks, 30); });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', reconcile);
  else reconcile();
})();
